import { useSelector } from 'react-redux';
import { masterDataSelector, activeCountriesSelector, filterParametersSelector } from '../state';

const useParametersLoading = () => {
  const masterData = useSelector(masterDataSelector);
  const activeCountries = useSelector(activeCountriesSelector);
  const parameters = useSelector(filterParametersSelector);

  const loading = masterData.loading || activeCountries.loading || parameters.loading;
  const loaded = masterData.loaded && activeCountries.loaded && parameters.loaded;
  const failure = masterData.failure || activeCountries.failure || parameters.failure;

  return { loading, loaded, failure };
};

export default useParametersLoading;
